/* eslint-disable react/jsx-indent */
import { format } from 'date-fns';
import { translate } from 'hooks/useTranslate';

import { EnvelopeStatus, EnvelopeWithStatus } from 'types/Envelope';
import { EnvelopeAPISigner } from 'types/EnvelopeSigners';

import { dateFormat } from 'constants/formats';

import { DATE_FORMAT_WITH_TIME } from 'constants/defaultConstants';

import EnvelopeBadges from '../components/EnvelopeBadges';
import { getEnvelopeStatusData } from './getEnvelopeStatusData';

export const formatDateTimeCell = (date: Date | undefined) => (
  <>{date ? format(new Date(date), DATE_FORMAT_WITH_TIME) : '-'}</>
);

export const formatSignersCell = (signers: EnvelopeAPISigner[]) => (
  <>
    {signers.length > 0
      ? signers?.map((signer, index) => (
          <>
            <div key={signer.email}>
              <b className="text-no-wrap">{signer.name}</b>
              &nbsp;
              <span className="text-muted">({signer.email})</span>
            </div>
            {index + 1 < signers.length ? <hr className="my-05" /> : null}
          </>
        ))
      : '-'}
  </>
);

export const formatStatusCell = (envelope: EnvelopeWithStatus) => {
  const { statusLabel, statusBadge, statusValue } = getEnvelopeStatusData({
    ...envelope,
    status: envelope?.envelopeStatus?.envelopeStatus.toUpperCase() || '',
  });

  return (
    EnvelopeBadges.Status && (
      <EnvelopeBadges.Status
        t={translate}
        style={statusBadge}
        text={statusLabel}
        status={statusValue}
      />
    )
  );
};

export const isNotValidEnvelope = (envelope: EnvelopeStatus) =>
  envelope.envelopeStatus === 'voided';

export const formatEnvelopesToExcel = (envelopes: EnvelopeStatus[]) =>
  envelopes
    .filter((envelope) => !isNotValidEnvelope(envelope))
    .map((env) => ({
      Sobre: env.envelopeInfo.envelopeId,
      Asunto: env.envelopeInfo.emailSubject,
      Beneficiario: env.signersStatus.pendingSigners
        .map((signer) => signer.name)
        .join(', '),
      BeneficiarioEmail: env.signersStatus.pendingSigners
        .map((signer) => signer.email)
        .join(', '),
      FechaEnvio: format(new Date(env.envelopeInfo.sentDateTime), dateFormat),
      FechaExpiracion: format(
        new Date(env.envelopeInfo.expireDateTime),
        dateFormat
      ),
      FechaModificacion: format(
        new Date(env.envelopeInfo.statusChangedDateTime),
        dateFormat
      ),
      Estado: env.envelopeStatus,
      FirmaronTodos: env.signersStatus.allSigned ? 'Sí' : 'No',
      FirmantesPendientes: env.signersStatus.pendingSigners.length,
      FirmantesCompletados: env.signersStatus.completedSigners.length,
    }));
